import { useEffect } from 'react';

import { queryClient } from '@hotjar/webapp/utils/react-query';
import { HIGHLIGHTS_LIST_QUERY_KEY } from '@hotjar/webapp/domains/highlights/api';

import { useUnseenHighlightsCount } from '../use-unseen-highlights-count';

export function useUnseenHighlightsReset(
  currentSiteId: Parameters<typeof useUnseenHighlightsCount>[0],
): void {
  const unseenHighlightsCount = useUnseenHighlightsCount(currentSiteId);

  useEffect(() => {
    if (typeof unseenHighlightsCount.value === 'undefined' || unseenHighlightsCount.value === 0) {
      return () => undefined;
    }

    const timeout = setTimeout(() => {
      queryClient.invalidateQueries(HIGHLIGHTS_LIST_QUERY_KEY);
    }, 5000);

    return () => clearTimeout(timeout);
  }, [unseenHighlightsCount.value]);
}
